import React from 'react';

function AboutPage() {
  return (
    <div className="about-container">
      <h1>Wie ben ik</h1>
      
      <div className="about-content-wrapper">
        <div className="text-content">
          <p>Ik houd van onderwijs in brede zin. Ik geniet van de vitaliteit van een school in bedrijf, van de opdracht om jonge mensen te laten groeien naar complete mensen en betekenisvolle burgers. Zoals ik ervan geniet om collega’s te zien groeien als professionals. Ik verwonder me tot op de dag van vandaag over de creativiteit waarmee leerlingen grenzen verkennen en de wijsheid waarmee docenten en begeleiders de leerlingen niet laten verdwalen bij hun verkenningen.</p>
          <p>Ik ben een lezer en een schrijver. Beide kan ik combineren in mijn literatuurcursussen en mijn UKV's. </p>
          <p>Ik gedraag mijzelf als een coachend leider. Het gaat me om processen en resultaten. Om het leren van organisaties en van de medewerkers daarbinnen.</p>
        </div>
        <img src="/MDA_About.jpg" alt="Foto van Maarten die spreekt" className="about-image" />
      </div>
    </div>
  );
}

export default AboutPage;
